import React from 'react';
import Form from '../../../../components/molecules/Form';

import FormActionShape from '../../../../lib/shapes/FormActionShape';
import SortChildPagesFormTemplate from './SortChildPagesFormTemplate';

export default function SortChildPagesForm({ form }) {
  return (
    <Form id="sort-childpages-form" model={form}>
      <SortChildPagesFormTemplate />
    </Form>
  );
}

SortChildPagesForm.propTypes = {
  form: FormActionShape.isRequired,
};
